var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{class:{ safe: true, chooseSafe: _vm.current === 1 },on:{"click":function($event){return _vm.tabClick(1)}}}),_c('div',{staticClass:"foot-split"}),_c('div',{staticClass:"number",class:{ number: true, chooseNumber: _vm.current === 3 },on:{"click":function($event){return _vm.tabClick(3)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }